import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BackendService } from './backend.service';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  baseURL = environment.baseUrl;

  constructor(private backendService: BackendService) {}

  sendContact(contactDetails: any): Observable<any> {
    return this.backendService.post(`${this.baseURL}/contact_us/`, contactDetails).pipe(map((res) => res));
  }
}
